import Component from '../core/Component'

const STATES = {
    ACTIVE: 'is-active',
}

export default class Crossroad extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            images: [],
            links: [],
        }

        this.state = {
            imageSelect: [],
            links: [],
            index: 0,
        }
    }

    prepare() {
        this.ref.images.forEach((image) => {
            this.state.imageSelect.push(image)
            image.classList.remove(STATES.ACTIVE)
        })

        this.state.imageSelect[0].classList.add(STATES.ACTIVE)

        this.ref.links.forEach((link) => {
            link.addEventListener('mouseenter', this.changeImage)
        })
    }

    changeImage = (event) => {
        let order = -1

        this.ref.links.forEach((link) => {
            order++
            if (link === event.target) {
                this.ref.images.forEach((image) => {
                    image.classList.remove(STATES.ACTIVE)
                })

                this.ref.images[order].classList.add(STATES.ACTIVE)
            }
        })
    }
}
